import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./sidebar-beta-label.module.scss";
import { classArr } from "../../helper/style-helper";

export interface SidebarBetaLabelProps {
	style?: React.CSSProperties;
	className?: string;
}

export default function SidebarBetaLabel(props: SidebarBetaLabelProps) {
	const { t } = useTranslation();
	return (
		<span
			style={props.style}
			className={classArr(styles.label, props.className)}
		>
			{t("common.beta")}
		</span>
	);
}
